<template>
  <vk-modal @close="$emit('close')">
    <div slot="header"></div>
    <div slot="content">
      <div class="m-x-2 m-x-6:t text-center">
        <div>
          We need additional information to complete your project request.
          Please contact our support team to continue with your request.
        </div>
        <div>
          <a href="tel:1-855-723-2266">
            1-855-723-2266
          </a> or email us at
          <a href="mailto:support@ProReferral.com">
            support@ProReferral.com
          </a>
        </div>
        <button
            class="btn m-t-2 p-8"
            @click="$emit('close')">
          Ok
        </button>
      </div>
    </div>
  </vk-modal>
</template>

<script>

export default {
  name: 'leads-modal',
};
</script>
